import cogoToast from "cogo-toast";
import { motion } from "framer-motion";
import React from "react";
import logoImg from '../../static/images/logo.png';
import { useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { followUser } from "../../services/userServices";
import { SHOW_UNFOLLOW_MODEL } from "../../store/model/modelSlice";
import { selectCurrentUser } from "../../store/user/userSelector";
import TextButton from "../Button/TextButton/TextButton";
import verifiedBadge from "../../static/images/icons8-verified-account-30.png";
import { BASE_WEB_URL } from "../../CONSTANTS";

export default function FollowUser({ user, type }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const currentUser = selectCurrentUser(state);
  const [followingText, setFollowingText] = useState("Following");
  const [following, setIsFollowing] = useState(user.isFollowing);

  const mutation = useMutation(followUser, {
    onSuccess: () => {
      // Invalidate and refetch
      setIsFollowing(true);
    },
    onError: (error) => {
      cogoToast.error(error.message);
    },
  });
  const getImage = (topic_assets) =>{
    if(!topic_assets) return logoImg;
    let i = topic_assets.findIndex(el => el.asset_type != 'audio' && el.asset_type != 'video' && el.asset_type != 'pdf');
    if(i > -1){
      return BASE_WEB_URL + topic_assets[i].asset_file;
    }else{
      return logoImg;
    }
  } 
  return (
    <motion.div
      className="follow-user"
      initial={{ opacity: 0.5 }}
      animate={{ opacity: 1 }}
    >
      <Link to={"/status/" + user.id} className="user-fullname">
      <div className="wrap-user">
        <div className="profile-pic-container">
          <img src={getImage(user.topic_assets)} alt="profile-pic" className="profile-pic" />
        </div>
        <div className="profile-details">
          
            <span className="user-username">{user.title}</span>
        </div>
      </div>
        </Link>
    </motion.div>
  );
}
